import { buildPath } from '@rentspree/path'
import { useContext } from 'react'
import { useMedia } from 'react-use'

import { AGENT_PROFILE_PUBLIC } from 'constant/route'
import { ListingIdContext } from 'context/listingIdContext'
import { useSelector } from 'store'
import { useTracker } from 'store/@hooks/use-tracker'
import {
  selectPublicListingScreeningRequest,
  selectPublicListingAgentContact,
} from 'store/public-listing'
import { selectUserProfile } from 'store/users/selectors'
import { events } from 'tracker'

import { ListingApplyPanelDesktop } from './apply-panel-desktop'
import { ListingApplyPanelMobile } from './apply-panel-mobile'

interface ListingApplyPanelProps {
  mobileRender?: boolean
  isPreview?: boolean
}

export const ListingApplyPanel = ({ mobileRender, isPreview }: ListingApplyPanelProps) => {
  const isMobile = useMedia('(max-width: 991px)')
  const track = useTracker()

  const profile = useSelector(selectUserProfile)
  const { url: screeningRequestApplyLink } = useSelector(selectPublicListingScreeningRequest)
  const agentContact = useSelector(selectPublicListingAgentContact)
  const listingId = useContext(ListingIdContext)
  const { LISTING_PUBLIC_PAGE } = events
  const AFFIX_OFFSET = 78

  const handleContactClick = () => {
    track(LISTING_PUBLIC_PAGE.CLICK_CONTACT_AGENT, { listing_id: listingId })
  }

  const handleApply = () => {
    const applyURIWithSource = screeningRequestApplyLink?.includes('?')
      ? screeningRequestApplyLink?.concat('&source=public_listing')
      : screeningRequestApplyLink?.concat('?source=public_listing')
    track(LISTING_PUBLIC_PAGE.CLICK_APPLY_ON_PUBLIC_LISTING_PAGE, { listing_id: listingId })
    window.location.assign(applyURIWithSource as string)
  }

  const handleAgentInfoClick = () => {
    track(LISTING_PUBLIC_PAGE.VIEW_AGENT_PROFILE_ON_PUBLIC_LISTING_PAGE, { listing_id: listingId })
    const targetPath = buildPath(AGENT_PROFILE_PUBLIC, { slug: agentContact.slug })
    window.open(targetPath)
  }
  const formattedAgentContactData = {
    ...agentContact,
    information: agentContact.brokerageName,
    subInformations: [agentContact.phone, agentContact.email],
  }

  if (isMobile !== mobileRender) return null

  if (isMobile) {
    return (
      <ListingApplyPanelMobile
        agentContact={formattedAgentContactData}
        handleAgentInfoClick={handleAgentInfoClick}
        handleApply={handleApply}
        handleContactClick={handleContactClick}
        isPreview={isPreview}
        profile={profile}
      />
    )
  }

  return (
    <ListingApplyPanelDesktop
      agentContact={formattedAgentContactData}
      handleAgentInfoClick={handleAgentInfoClick}
      handleApply={handleApply}
      handleContactClick={handleContactClick}
      offset={AFFIX_OFFSET}
      isPreview={isPreview}
      profile={profile}
    />
  )
}

ListingApplyPanel.defaultProps = {
  isPreview: false,
  mobileRender: false,
}
